// extracted by mini-css-extract-plugin
export default {"name":"OrganizationName_name__acZqX","edit":"OrganizationName_edit__UGIKf"};